angular.module('authoring.bootstrap.tabs', [])

  .controller('AuthoringTabsetController', ['$scope', '$interval', function($scope, $interval) {
    var ctrl = this, oldIndex;
    ctrl.tabs = [];
    ctrl.arrayStyle = {visibility: "hidden"}
    ctrl.totalWidth = 0;
    ctrl.arrayVPromise = null;
    ctrl.resizeListener = function(event) {
        ctrl.updateArrowsVisibility();
        $scope.$digest();
    };

    // iVeBeenDismissed
    $scope.$on('$destroy', () => {
        window.removeEventListener("resize", ctrl.resizeListener);
        $interval.cancel(ctrl.arrayVPromise)
    })

    // readyToTrick
    $scope.$on('$includeContentLoaded', () => {
        window.addEventListener("resize", ctrl.resizeListener);
    });

    ctrl.select = function(index, evt) {
      if (!destroyed) {
        var previousIndex = findTabIndex(oldIndex);
        var previousSelected = ctrl.tabs[previousIndex];
        if (previousSelected) {
          previousSelected.tab.onDeselect({
            $event: evt,
            $selectedIndex: index
          });
          if (evt && evt.isDefaultPrevented()) {
            return;
          }
          previousSelected.tab.active = false;
        }

        var selected = ctrl.tabs[index];
        if (selected) {
          selected.tab.onSelect({
            $event: evt
          });
          selected.tab.active = true;
          ctrl.active = selected.index;
          oldIndex = selected.index;
          ctrl.updateOffset(index);
          ctrl.updateArrows();
          ctrl.updateArrowsVisibility();
        } else if (!selected && angular.isDefined(oldIndex)) {
          ctrl.active = null;
          oldIndex = null;
        }
      }
    };

    // contentUI: added method
    ctrl.selectPrev = (evt) => {
      var index = ctrl.findPrevEnabled();
      if (index === undefined) { // Try loop around
        index = ctrl.findLastEnabled();
      }
      if (index !== undefined) {
        setTimeout(function () { ctrl.tabs[index].tab.focus(evt); }, 500);
        ctrl.select(index, evt);
      }
    };

    // contentUI: added method
    ctrl.selectNext = (evt) => {
      var index = ctrl.findNextEnabled();
      if (index === undefined) { // Try loop around
        index = ctrl.findFirstEnabled();
      }
      if (index !== undefined) {
        setTimeout(function () { ctrl.tabs[index].tab.focus(evt); }, 500);
        ctrl.select(index, evt);
      }
    };

    // contentUI: added method
    ctrl.findFirstEnabled = () => {
      for (var i = 0; i < ctrl.tabs.length; i++) {
        if (!ctrl.tabs[i].tab.disabled) {
          return i;
        }
      }
      return undefined;
    };

    // contentUI: added method
    ctrl.findLastEnabled = () => {
      for (var i = ctrl.tabs.length - 1; i >= 0; i--) {
        if (!ctrl.tabs[i].tab.disabled) {
          return i;
        }
      }
      return undefined;
    };

    // contentUI: added method
    ctrl.findPrevEnabled = () => {
      var enabled = undefined;
      for (var i = 0; i < ctrl.tabs.length && ctrl.tabs[i].index !== ctrl.active; i++) {
        if (!ctrl.tabs[i].tab.disabled) {
          enabled = i;
        }
      }
      return i < ctrl.tabs.length ? enabled : undefined;
    };

    // contentUI: added method
    ctrl.findNextEnabled = () => {
      var enabled = undefined;
      for (var i = ctrl.tabs.length - 1; i >= 0 && ctrl.tabs[i].index !== ctrl.active; i--) {
        if (!ctrl.tabs[i].tab.disabled) {
          enabled = i;
        }
      }
      return i >= 0 ? enabled : undefined;
    };

    // contentUI: added method
    ctrl.updateArrows = () => {
      ctrl.hasPrev = ctrl.findPrevEnabled() !== undefined;
      ctrl.hasNext = ctrl.findNextEnabled() !== undefined;
    };

    /**
     *  Authoring UI: added method,
     *  Update the visibility of the arrows
     *  when all tabs are visible, hide both arrows
     */
    ctrl.updateArrowsVisibility = () => {
      if (ctrl.tabs.length > 0) {
        if (ctrl.tabs[0] && ctrl.tabs[0].tab && ctrl.tabs[0].tab.parentWidth) {
          var containerWidth = ctrl.tabs[0].tab.parentWidth();
          if (containerWidth === 0) {
              ctrl.arrayVPromise = $interval(ctrl.updateArrowsVisibility, 500, 1)
          } else {
              if (ctrl.totalWidth < containerWidth) {
                  ctrl.arrayStyle.visibility = "hidden";
              } else {
                  ctrl.arrayStyle.visibility = "visible";
              }
          }
        }
      }
    };

    /**
     *  Authoring UI: added method,
     *  Updatet the offset of the tabs, and calculate the totalWidth of all tabs
     *  Note: Must be called before 'updateArrowsVisibility'
     */
    ctrl.updateOffset = (index) => {
      if (!ctrl.tabs[index]) {
        return;
      }
      ctrl.totalWidth = 0;
      var baseOffset = 0;
      var margins = [0];
      var widths = [];
      for (var i = 0; i < ctrl.tabs.length; i++) {
        var tab = ctrl.tabs[i].tab;
        margins[i] += tab.elementMarginLeft();
        widths[i] = tab.elementWidth();
        margins[i + 1] = tab.elementMarginRight();

        ctrl.totalWidth += margins[i] + widths[i];
        if (i <= index) {
            baseOffset += margins[i] + widths[i];
        }
      }
      baseOffset -= widths[index] / 2;
      ctrl.totalWidth += margins[ctrl.tabs.length];
      var containerWidth = ctrl.tabs[index].tab.parentWidth();

      if (ctrl.totalWidth < containerWidth || baseOffset < containerWidth / 2) {
        ctrl.offset = 0;
      } else if (ctrl.totalWidth - baseOffset < containerWidth / 2) {
        ctrl.offset = containerWidth - ctrl.totalWidth;
      } else {
        ctrl.offset = containerWidth / 2 - baseOffset;
      }
    };

    ctrl.addTab = (tab) => {
      ctrl.tabs.push({
        tab: tab,
        index: tab.index
      });

      // contentUI: removed sort

      if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
        var newActiveIndex = findTabIndex(tab.index);
        ctrl.select(newActiveIndex);
      }

      // contentUI: added offset check
      var index = findTabIndex(ctrl.active);
      if (index !== undefined) {
        setTimeout(function () { ctrl.updateOffset(index); }, 250);
      }

      // contentUI: added arrow check
      ctrl.updateArrows();
    };

    ctrl.removeTab = (tab) => {
      var index;
      for (var i = 0; i < ctrl.tabs.length; i++) {
        if (ctrl.tabs[i].tab === tab) {
          index = i;
          break;
        }
      }

      if (ctrl.tabs[index].index === ctrl.active) {
        var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
          index - 1 : index + 1 % ctrl.tabs.length;
        ctrl.select(newActiveTabIndex);
      }

      ctrl.tabs.splice(index, 1);
    };

    $scope.$watch('tabset.active', function(val) {
      if (angular.isDefined(val) && val !== oldIndex) {
        ctrl.select(findTabIndex(val));
      }
    });

    var destroyed;
    $scope.$on('$destroy', function() {
      destroyed = true;
    });

    function findTabIndex(index) {
      for (var i = 0; i < ctrl.tabs.length; i++) {
        if (ctrl.tabs[i].index === index) {
          return i;
        }
      }
    }
  }])

  .directive('authoringTabset', function() {
    return {
      transclude: true,
      replace: true,
      scope: {},
      bindToController: {
        active: '=?',
        type: '@'
      },
      controller: 'AuthoringTabsetController',
      controllerAs: 'tabset',
      templateUrl: function(element, attrs) {
        return attrs.templateUrl || 'authoring/template/tabs/tabset.html';
      },
      link: function(scope, element, attrs) {
        scope.vertical = angular.isDefined(attrs.vertical) ?
          scope.$parent.$eval(attrs.vertical) : false;
        scope.justified = angular.isDefined(attrs.justified) ?
          scope.$parent.$eval(attrs.justified) : false;
      }
    };
  })

  .directive('authoringTab', ['$parse', function($parse) {
    return {
      require: '^authoringTabset',
      replace: true,
      templateUrl: function(element, attrs) {
        return attrs.templateUrl || 'authoring/template/tabs/tab.html';
      },
      transclude: true,
      scope: {
        heading: '@',
        index: '=?',
        classes: '@?',
        onSelect: '&select', //This callback is called in contentHeadingTransclude
        //once it inserts the tab's content into the dom
        onDeselect: '&deselect'
      },
      controller: function() {
        //Empty controller so other directives can require being 'under' a tab
      },
      controllerAs: 'tab',
      link: function(scope, elm, attrs, tabsetCtrl, transclude) {
        scope.disabled = false;
        if (attrs.disable) {
          scope.$parent.$watch($parse(attrs.disable), function(value) {
            scope.disabled = !!value;
          });
        }

        if (angular.isUndefined(attrs.index)) {
          if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
            scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function(t) { return t.index; })) + 1;
          } else {
            scope.index = 0;
          }
        }

        if (angular.isUndefined(attrs.classes)) {
          scope.classes = '';
        }

        scope.select = function(evt) {
          if (!scope.disabled) {
            var index;
            for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
              if (tabsetCtrl.tabs[i].tab === scope) {
                index = i;
                break;
              }
            }

            tabsetCtrl.select(index, evt);
          }
        };

        // contentUI: added method
        scope.focus = function(evt) {
          elm.children()[0].focus();
        };

        // contentUI: added method
        scope.keydown = function(evt) {
          if (evt.which === 39 || evt.which === 40) {
            tabsetCtrl.selectNext();
          } else if (evt.which === 37 || evt.which === 38) {
            tabsetCtrl.selectPrev();
          }
        };

        // contentUI: added method
        scope.elementWidth = function () {
          return elm[0].offsetWidth;
        };

        // contentUI: added method
        scope.elementMarginLeft = function() {
          var style = getComputedStyle(elm[0]);
          return style.display === "none" ? 0 : parseInt(style.marginLeft);
        };

        // contentUI: added method
        scope.elementMarginRight = function() {
          var style = getComputedStyle(elm[0]);
          return style.display === "none" ? 0 : parseInt(style.marginRight);
        };

        // contentUI: added method
        scope.parentWidth = function() {
          return elm[0].parentElement.parentElement.clientWidth;
        };

        tabsetCtrl.addTab(scope);
        scope.$on('$destroy', function() {
          tabsetCtrl.removeTab(scope);
        });

        //We need to transclude later, once the content container is ready.
        //when this link happens, we're inside a tab heading.
        scope.$transcludeFn = transclude;
      }
    };
  }])

  .directive('authoringTabHeadingTransclude', function() {
    return {
      restrict: 'A',
      require: '^authoringTab',
      link: function(scope, elm) {
        scope.$watch('headingElement', (heading) => {
          if (heading) {
            elm.html('');
            elm.append(heading);
          }
        });
      }
    };
  })

  .directive('authoringTabContentTransclude', function() {
    return {
      restrict: 'A',
      require: '^authoringTabset',
      link: function(scope, elm, attrs) {
        var tab = scope.$eval(attrs.authoringTabContentTransclude).tab;

        //Now our tab is ready to be transcluded: both the tab heading area
        //and the tab content area are loaded.  Transclude 'em both.
        tab.$transcludeFn(tab.$parent, function(contents) {
          angular.forEach(contents, function(node) {
            if (isTabHeading(node)) {
              //Let tabHeadingTransclude know.
              tab.headingElement = node;
            } else {
              elm.append(node);
            }
          });
        });
      }
    };

    function isTabHeading(node) {
      return node.tagName && (
        node.hasAttribute('authoring-tab-heading') ||
        node.hasAttribute('data-authoring-tab-heading') ||
        node.hasAttribute('x-authoring-tab-heading') ||
        node.tagName.toLowerCase() === 'authoring-tab-heading' ||
        node.tagName.toLowerCase() === 'data-authoring-tab-heading' ||
        node.tagName.toLowerCase() === 'x-authoring-tab-heading' ||
        node.tagName.toLowerCase() === 'authoring:tab-heading'
      );
    }
  });



// WEBPACK FOOTER //
// ./app/common/tabs/tabs.js